import React from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { DateInput, FormCheck } from "../../forms";
import { BooleanSelect, ClientProjectSelect, DocumentTypesSelect, DocumentFunctionsSelect, GenericUserSelect } from "../../forms/selects";

export const DocumentFilterForm = ({ isClientLevel = true } : Readonly<{ isClientLevel: boolean }>) => {
    const { control, setValue, watch } = useFormContext();
    return (
        <div className="row gy-2">
            <div className="col-4">
                <Controller
                    name="documentTypes"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <DocumentTypesSelect
                            label="Document Types"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onChange={(values : any) => setValue('documentTypes', values.map((el : any) => el.value), { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-4">
                <Controller
                    name="documentFunctions"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <DocumentFunctionsSelect
                            label="Document Functions"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(values) => {
                                if (values.map((el: any) => el.label).some((label: any) => label.includes("Report"))) {
                                    setValue('hideReportDocs', false, { shouldDirty: true });
                                }
                                setValue('documentFunctions', values.map((el: any) => el.value), { shouldDirty: true });
                            }}
                        />
                    )}
                />
            </div>
            <div className="col-4">
                <Controller
                    name="clientReadable"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <BooleanSelect 
                            label="Client Access"
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(e: any) => setValue('clientReadable', e.value, { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            {isClientLevel && (
                <div className="col-6">
                    <Controller
                        name="projectIds"
                        control={control}
                        render={({ field: { ref, value, onChange, ...rest } }) => (
                            <ClientProjectSelect 
                                ref={ref}
                                label={"Projects"} 
                                isMulti={true}
                                value={value}
                                disableAnimations={true}
                                setValue={(values: any) => setValue('projectIds', values.map((el: any) => el.value), { shouldDirty: true })}
                            />
                        )}
                    />
                </div>
            )}
            <div className={classNames({
                "col-6": isClientLevel,
                "col-12": !isClientLevel
            })}>
                <Controller
                    name="uploadedByUserIds"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <GenericUserSelect
                            label="Uploaded By"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onChange={(values: any) => setValue('uploadedByUserIds', values.map((el: any) => el.value), { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="dateUploadedFrom"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <DateInput
                            label="Date Uploaded From"
                            isClearable
                            disableAnimations={true}
                            value={value}
                            placeholder="Date Uploaded From"
                            onChange={(value: any) => setValue('dateUploadedFrom', value, { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-6">
                <Controller
                    name="dateUploadedTo"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <DateInput
                            label="Date Uploaded To"
                            isClearable
                            disableAnimations={true}
                            placeholder="Date Uploaded To"
                            value={value}
                            onChange={(value: any) => setValue('dateUploadedTo', value, { shouldDirty: true })}
                        />
                    )}
                />
            </div>
            <div className="col-12 pt-2">
                <Controller
                    name="hideReportDocs"
                    control={control}
                    render={({ field: { ref, value, onChange, ...rest } }) => (
                        <FormCheck
                            isChecked={value}
                            label="Hide Report Documents"
                            onChange={(value: any) => setValue("hideReportDocs", value, { shouldDirty: true })}
                            disableAnimations
                        />
                    )}
                />
            </div>
        </div>
    );
};